import { ReactNode } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import LockOutlined from '@ant-design/icons/LockOutlined';
import { useNavigate } from 'react-router-dom';
import PermissionGuard from './PermissionGuard';

const SemAcesso = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <Stack alignItems="center" spacing={2} sx={{ p: 4, maxWidth: 420, textAlign: 'center' }}>
        <LockOutlined style={{ fontSize: 48, color: '#94A3B8' }} />
        <Typography variant="h5">Sem acesso</Typography>
        <Typography variant="body2" color="text.secondary">
          Você não tem permissão para acessar esta seção. Solicite acesso ao administrador se acredita que isso é um engano.
        </Typography>
        <Button variant="outlined" onClick={() => navigate('/dashboard')}>
          Voltar ao dashboard
        </Button>
      </Stack>
    </Box>
  );
};

interface RouteGuardProps {
  permissions?: string | string[];
  /** Um prefixo ou vários (ex.: `"admin."`). Qualquer um que case já libera. */
  permissionsPrefix?: string | string[];
  children: ReactNode;
}

/**
 * Wrapper de rota que mostra página "sem acesso" se o user não tem permissão.
 * Diferente do PermissionGuard puro (que retorna fallback inline), esse é pra
 * proteger PÁGINAS inteiras — substitui o conteúdo por uma UX clara.
 *
 * **Aceita mais de um critério, combinados em OR** (lista de permissões *ou* lista de prefixos) —
 * ver a nota do `PermissionGuard`. É o que permite um grupo de rotas cujas telas não compartilham
 * um prefixo único, como `/admin`, ser coberto sem barrar quem tem direito a uma delas.
 */
const RouteGuard = ({ permissions, permissionsPrefix, children }: RouteGuardProps) => (
  <PermissionGuard permissions={permissions} permissionsPrefix={permissionsPrefix} fallback={<SemAcesso />}>
    {children}
  </PermissionGuard>
);

export default RouteGuard;
